export const onlyNumericRegex = /^[0-9]*$/;
export const onlyAlphaRegex = /^[A-Za-záéíóúÁÉÍÓÚñÑ ]*$/;
export const onlyAlphaOneSpaceRegex =
    /^([A-Za-záéíóúÁÉÍÓÚñÑ]+\s)*[A-Za-záéíóúÁÉÍÓÚñÑ]*$/;
export const alphaNumericregex = /^[A-Za-záéíóúÁÉÍÓÚñÑ0-9 ]*$/;
export const emailRegex =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const phoneRegex = /^9[0-9]{8}$/;
export const currencyAmountRegex = /^S\/ \d{1,3}( \d{3})*\.{0,1}\d{0,2}$/;
